import { ReactNode, useEffect, useState } from "react";

import WebEntryAlert from "@/shared/components/WebEntryAlert";

const isWebEntry = () => {
  return typeof window !== "undefined" && !window.flutter_inappwebview;
};

interface WebEntryProviderProps {
  children: ReactNode;
}

export default function WebEntryProvider({ children }: WebEntryProviderProps) {
  const [shouldBlockWebEntry, setShouldBlockWebEntry] = useState(false);

  useEffect(() => {
    setShouldBlockWebEntry(isWebEntry());
  }, []);

  return (
    <>
      {children}
      <WebEntryAlert isOpen={shouldBlockWebEntry} />
    </>
  );
}
